import Vue from 'vue';
import Antd from 'ant-design-vue';

import './styles/antd-variables.less';
import './styles/main.less';
import './registerServiceWorker';
import i18n from './i18n';
import fb from './firebaseConfig';
import router from './router';
import App from './App.vue';
import store from './store';
import { SET_CURRENT_USER } from './store/constants.js';

Vue.config.productionTip = false;
Vue.use(Antd);

window.__app__;

// handle page reload
fb.auth.onAuthStateChanged(user => {
  if (user) {
    store.commit('auth/' + SET_CURRENT_USER, user);
    store.dispatch('auth/fetchUserProfile');
  } else {
    store.commit('auth/' + SET_CURRENT_USER, null);
  }
  if (!window.__app__) {
    window.__app__ = new Vue({
      router,
      store,
      i18n,
      render: h => h(App)
    }).$mount('#app');
  }
});
